<template>
  <article class="fc-intr-process">
    <header class="fc-intr-process__header">
      <slot name="intr-process-header">
        <div class="fc-intr-process__box">
          <nav class="fc-intr-process__header-item">
            <mds-button type="button" on-dark variation="flat" class="fc-intr-process__back-button" @click="goBack">
              <mds-icon name="caret-left" class="back-icon"></mds-icon>
              <span class="back-text">Back</span>
            </mds-button>
          </nav>
          <div role="title">
            <h3 class="fc-intr-process__header-item fc-intr-process__header-title">
              {{processName}}
            </h3>
          </div>
          <nav class="fc-intr-process__header-item"></nav>
        </div>
      </slot>
    </header>
    <section class="fc-intr-process__main whiteLayout" :class="{'no-background': !withMainBackground}">
      <div class="fc-intr-process__box">
        <slot name="intr-process-action-bar" />
        <slot></slot>
      </div>
    </section>
    <footer class="fc-intr-process__footer" :class="{'no-background': !withFooterBackground}"></footer>
  </article>
</template>

<script>
export default {
  name: 'internal-process',
  props: {
    withMainBackground: {
      type: Boolean,
      default: true,
    },
    withFooterBackground: {
      type: Boolean,
      default: true,
    },
    processName: {
      type: String,
      required: true,
    },
  },
  methods: {
    goBack() {
      this.$emit('go-back');
    },
  },
};
</script>

<style lang="scss" scoped>
.fc-intr-process__box {
  max-width: 1200px;
  flex: 1;
}

.fc-intr-process, #app article:not(.tooltip).fc-intr-process {
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  min-height: calc(100vh - 40px - 80px);

  .fc-intr-process__margin {
    background-color: $fc-main-color;
  }

  .fc-intr-process__header {
    background-color: $fc-main-color;
    color: $mds-text-color-primary-on-dark;
    max-height: 173px;
    height: 173px;
    .fc-intr-process__box {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      margin-left: auto;
      margin-right: auto;
      .fc-intr-process__header-title {
        @include mds-level-2-heading($bold: true);
        align-content: center;
      }
      .fc-intr-process__header-item {
        flex: 1 1 0;
      }
    }
  }

  .fc-intr-process__back-button {
    @include mds-link($underline: false);
    font-size: 1rem;
    color: $fc-soft-gray;
    &:visited {
      .back-icon, .back-text {
        @include mds-icon-color($fc-soft-gray);
        color: $fc-soft-gray;
      }
    }
    &:hover, &:focus {
      .back-icon, .back-text {
        @include mds-icon-color($mds-text-color-primary-on-dark);
        color: $mds-text-color-primary-on-dark;
      }
    }
    .back-icon, .back-text {
      @include mds-icon-color($fc-soft-gray);
      transition: all 0.5s ease;
      color: $fc-soft-gray;
      height: 17px;
    }
  }

  .fc-intr-process__main {
    background-color: $fc-main-color;
    display: flex;
    flex-direction: row;
    .fc-intr-process__box {
      background-color: $mds-text-color-primary-on-dark;
      min-height: 200px;
      height: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
    &.no-background {
      @include fc-no-background();
    }
  }

  .fc-intr-process__footer {
    flex: 1;
    min-height: 80px;
    background-color: $fc-main-color;
    &.no-background {
      @include fc-no-background();
    }
  }
}
</style>
